// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iY","advertCardHeader__actions":"c-a_iZ","advertCardHeader__bottomLabel":"c-a_ja"};